// Normalize a user-entered URL for use as an external link's href.
//
// Browsers treat a scheme-less value (e.g. "store.com/item") as a path
// relative to the current page, so an in-app <a href> would navigate within
// the SPA — landing on a non-existent route (Forbidden) instead of opening the
// external site. Prepend https:// when no scheme is present.
export function externalHref(url) {
  if (!url) return url
  const trimmed = String(url).trim()
  if (!trimmed) return trimmed
  // Already has a scheme (http://, https://, mailto:, etc.) — leave as-is.
  if (/^[a-z][a-z\d+.-]*:/i.test(trimmed)) return trimmed
  // Protocol-relative (//host/...) — let the browser keep the page scheme.
  if (trimmed.startsWith('//')) return trimmed
  return `https://${trimmed}`
}
